import { CFooter } from '@coreui/react';
import { changeLanguage } from 'utils/helpers';

const Footer = () => {
  return (
    // CoreUI 5's footer is a div; the role keeps the landmark of the <footer> CoreUI 3 rendered.
    <CFooter role="contentinfo" onClick={changeLanguage}>
      <div className="ms-auto">
        <span className="me-1">
          Copyright © {new Date().getFullYear()} HYPO NOE Landesbank für Niederösterreich und Wien
          AG
        </span>
      </div>
    </CFooter>
  );
};

export default Footer;
